import { render } from "./PageFooter.vue?vue&type=template&id=2f352c16"
import script from "./PageFooter.vue?vue&type=script&lang=js"
export * from "./PageFooter.vue?vue&type=script&lang=js"

import "./PageFooter.vue?vue&type=style&index=0&id=2f352c16&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Sub4Turismo\\FrontSite\\CodigoVueSub4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__